import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
                {appEntry.title}
              </h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed max-w-[560px] lg:max-w-none mb-6">
                {appEntry.desc}
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <a
                  href="#hero"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors duration-200"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
                <a
                  href="#hero"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-300 text-background-50 font-medium text-sm hover:bg-primary-400 transition-colors duration-200"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[440px]">
              <div className="bg-primary-600/30 backdrop-blur-sm rounded-2xl p-5 md:p-6 border border-primary-400/20">
                <div className="flex flex-wrap gap-2.5">
                  {appEntry.features.map((feat) => (
                    <span
                      key={feat}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs font-medium"
                    >
                      <i className="ri-check-line text-sm"></i>
                      {feat}
                    </span>
                  ))}
                </div>
                <div className="mt-6 text-center">
                  <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/10 text-background-50/80 text-xs">
                    <i className="ri-smartphone-line"></i>
                    扫码下载，即刻体验
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}